import React from 'react'
import Chat from './Chat'

function Chats() {
    return (
        <div className="chats">
            <Chat
                name="Charlotte"
                message="The time has come my child"
                timestamp="40 second ago"
                profilePic="https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg"
            />
            <Chat
                name="Charlotte"
                message="The time has come my child"
                timestamp="40 second ago"
                profilePic="https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg"
            />
            <Chat
                name="Charlotte"
                message="The time has come my child"
                timestamp="40 second ago"
                profilePic="https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg"
            />
        </div>
    )
}

export default Chats
